// The skills product companies and AI startups hire for, in the order
// interviews usually test them. Each stage links to the matching programs.
export const careerRoadmap = [
  {
    id: 'build',
    title: 'Build real products',
    tagline: 'Ship apps the way product teams do',
    outcome: 'Walk into machine-coding rounds having already shipped real, deployed products.',
    hiring: ['Product companies', 'AI startups'],
    tests: 'Machine-coding rounds and take-home assignments: can you build a working, well-structured feature end to end?',
    build: ['Production-grade React and Node.js or Spring Boot apps', 'REST APIs with auth, databases and tests', 'Deployed projects you can demo in interviews'],
    rounds: ['Machine coding', 'Take-home', 'Project deep-dive'],
    courses: ['Full-Stack Web Development', 'Java Full-Stack'],
    accent: ['#22d3ee', '#6366f1']
  },
  {
    id: 'solve',
    title: 'Crack problem solving',
    tagline: 'Think in patterns, not memorised answers',
    outcome: 'Recognise the pattern behind new problems and solve them calmly, instead of hoping you have seen them before.',
    hiring: ['Product companies'],
    tests: 'Online assessments and DSA rounds: can you find an efficient solution, explain it and handle edge cases under time pressure?',
    build: ['A toolkit of DSA patterns: two pointers, sliding window, graphs, DP', 'The habit of thinking aloud and analysing complexity', 'Speed and accuracy with timed practice'],
    rounds: ['Online assessment', 'DSA rounds', 'Problem solving'],
    courses: ['Data Structures & Algorithms'],
    accent: ['#4ade80', '#14b8a6']
  },
  {
    id: 'design',
    title: 'Design at scale',
    tagline: 'Reason about systems serving millions',
    outcome: 'Lead design discussions with confidence, the skill that separates senior offers from the rest.',
    hiring: ['Product companies', 'AI startups'],
    tests: 'High-level and low-level design rounds: can you clarify requirements, make trade-offs and design for scale and failure?',
    build: ['Designs for real systems: URL shortener, feeds, chat, payments', 'Caching, sharding, queues and consistency trade-offs', 'Clean class design and design patterns for LLD'],
    rounds: ['HLD', 'LLD', 'Architecture discussion'],
    courses: ['System Design'],
    accent: ['#60a5fa', '#a855f7']
  },
  {
    id: 'ai',
    title: 'Build with AI',
    tagline: 'The skill AI-first teams look for',
    outcome: 'Stand out with AI skills most engineers do not have yet, exactly what AI startups are hiring for.',
    hiring: ['AI startups', 'Product companies'],
    tests: 'AI project and design discussions: can you build reliable LLM features with tools, retrieval and evaluation, not just call an API?',
    build: ['Agents that use tools and take actions', 'RAG over your own data with evals', 'Production concerns: cost, latency, safety and monitoring'],
    rounds: ['AI project deep-dive', 'LLM system design'],
    courses: ['Agentic AI'],
    accent: ['#f472b6', '#a855f7']
  }
];
